// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3k7Ro","HeaderWrap":"Header_HeaderWrap__3EIJZ","Logo":"Header_Logo__3TQJS"};